import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import FragHans from './FragHans';

export default function FragHansPage() {
  const location = useLocation();
  const initialMessage = location.state?.initialMessage;
  const sentRef = useRef(false);

  useEffect(() => {
    if (initialMessage && !sentRef.current) {
      sentRef.current = true;
      // Clear history state so reload does not resend
      window.history.replaceState({}, '');
    }
  }, [initialMessage]);

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="frag-hans-page">
      <Header />
      <main className="flex-1 flex flex-col">
        <FragHans variant="page" initialMessage={initialMessage} />
      </main>
    </div>
  );
}
